import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { useUserCanPredeliver } from 'src/hooks/useUserHasListingPermissions';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkUpdateBarcodes = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const hasPredeliverPermission = useUserCanPredeliver(
    undefined, // listing
    true // forBulkEdit
  );

  if (!hasPredeliverPermission) {
    return null;
  }

  return (
    <PosDropdownItem
      key="BulkUpdateBarcodes"
      onClick={onClick}
      disabled={disabled}
    >
      <Stack alignItems="center" gap="m" width="full">
        <Content id={ContentId.UploadBarcodes} />
      </Stack>
    </PosDropdownItem>
  );
};
